import idleTimer from './idle-timer';
import Cviceni from './cviceni';
import Navigation from './navigation';
import Slides from './slides';
import SaveData from './save-data';
import Analytics from './analytics';
import Forms from './forms';
import ModuleStore from './module-store';

import polyfillNodelistForeach from '../lib/polyfill-nodelist-foreach';

// Edge doesn't support:
// .forEach() on NodeLists
polyfillNodelistForeach();

function initSourceWorkTool() {
  const elements = document.querySelectorAll('source-work-tool[data-configuration]');

  elements.forEach((element) => {
    const rawConfig = element.getAttribute('data-configuration');
    const rawDeps = element.getAttribute('data-dependency-data');

    if (!rawConfig) return;

    try {
      const configuration = JSON.parse(rawConfig);
      element.configuration = configuration;
    } catch (error) {
      // Keep rendering resilient if malformed config slips into template data.
      // eslint-disable-next-line no-console
      console.error('[source-work-tool] invalid data-configuration JSON', error);
    }

    if (rawDeps) {
      try {
        const dependencyData = JSON.parse(rawDeps);
        element.dependencyData = dependencyData;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[source-work-tool] invalid data-dependency-data JSON', error);
      }
    }
  });

  return elements;
}

const domLoad = () => {
  console.log('domLoad:cviceni');

  const $root = document.documentElement;

  // instantiate
  HISTORYLAB.analytics = new Analytics();
  const cviceni = new Cviceni();
  const navigation = new Navigation();
  const slides = new Slides();
  const data = new SaveData();
  const forms = new Forms();

  // Create testing helper object (for Cypress tests)
  // HISTORYLAB must remain unchanged for backend compatibility
  window.HISTORYLAB_MANUAL_IMPORT = {
    saveData: data,

    // Helper method for reloading exercise data during tests
    reloadExerciseData: function(exerciseData) {
      console.log('🔄 Reloading exercise data:', exerciseData);

      // Update import object
      HISTORYLAB.import.done = true;
      HISTORYLAB.import.exerciseData = exerciseData;

      // Update isDone property on SaveData instance (inherited from Cviceni)
      data.isDone = true;

      // Reload data into SaveData instance
      data.checkForData(exerciseData);

      // Re-initialize to update UI state
      data.init();

      console.log('✅ Exercise data reloaded successfully');
    }
  };

  // run
  navigation
    .loopNavButtons();

  slides
    .slides();

  data
    .checkForData(HISTORYLAB.import.exerciseData || {})
    .init();

  cviceni
    .header();

  forms
    .init();

  const swtElements = initSourceWorkTool();
  const moduleStore = new ModuleStore();
  moduleStore.register(swtElements);

  idleTimer({
    // function to fire after idle
    callback: () => $root.classList.add('is-idle'),
    // function to fire when active
    activeCallback: () => $root.classList.remove('is-idle'),
    // Amount of time in milliseconds before becoming idle. default 60000
    idleTime: 3000,
  });

  // if (HISTORYLAB.import.done) {
  //   const $srcs = document.querySelectorAll('audio, video, source, img, image');
  //   const replace = ((src) => src.replace('/cviceni-aktualni', '..'));

  //   $srcs.forEach(($src) => {
  //     switch ($src.nodeName) {
  //       case 'AUDIO':
  //       case 'IMG':
  //       case 'SOURCE':
  //       case 'VIDEO':
  //         $src.setAttribute(
  //           'src',
  //           replace($src.getAttribute('src')),
  //         );

  //         break;

  //       case 'image':
  //         $src.setAttribute(
  //           'xlink:href',
  //           replace($src.getAttribute('xlink:href')),
  //         );
  //         break;

  //       default:
  //         break;
  //     }
  //   });
  // }
};

export default domLoad;
